module.exports = __webpack_public_path__ + "static/img/error-bg.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/error-bg.png
// module id = 529
// module chunks = 0